export default {
  init() {
    jQuery(document).ready(function ($) {
      // Filter dropdown
      $(".activities__filter-list-item").on("click", function (e) {
        e.preventDefault();
        $(this)
          .closest("ul.activities__filter-list")
          .toggleClass("activities__filter-list--active");
      });
    });

    jQuery(".activities__share-icon").on("click", function () {
      var area = jQuery(this).attr("data-termslug");
      var copyText = document.getElementById("myInput" + area);
      copyText.select();
      copyText.setSelectionRange(0, 99999);
      navigator.clipboard.writeText(copyText.value);
      jQuery(".tooltiptext").text("Kopiera länk");
      jQuery(this).find(".tooltiptext").text("Kopierad");
    });
  },
};
